import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';
import { createEpicMiddleware } from 'redux-observable';
import epics from './epics';
import trimFields from './trimFields';
const isDevelopmentEnv = true;

const epicMiddleware = createEpicMiddleware();
let defaultMiddleware = [thunk, epicMiddleware, trimFields];

export default function configureStore(initialState, middleware = []) {
  const composeEnhancers =
    isDevelopmentEnv && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;
  const store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...defaultMiddleware, ...middleware)));
  epicMiddleware.run(epics);
  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const nextRootReducer = require('./reducers').default;
      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
}
